function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "magnifier_searchfield");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M447,428,337.4,318.4a191.52,191.52,0,0,0,47.2-126.1C384.6,86.2,298.3,0,192.3,0S0,86.3,0,192.3,86.3,384.6,192.3,384.6a191.52,191.52,0,0,0,126.1-47.2L428,447a13.59,13.59,0,0,0,9.5,4,13.17,13.17,0,0,0,9.5-4A13.52,13.52,0,0,0,447,428ZM192.2,357.7c-91.1,0-165.3-74.2-165.3-165.4S101.1,27,192.2,27s165.3,74.2,165.3,165.3S283.4,357.7,192.2,357.7Z",
  fill: "#6c6c6c"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M310.23,174.36a119.56,119.56,0,0,0-118-101.42,120.86,120.86,0,0,0-15.81,1A6,6,0,0,0,178,85.88a108.89,108.89,0,0,1,14.23-.94,107.55,107.55,0,0,1,106.16,91.22,6,6,0,0,0,5.93,5.1,5.46,5.46,0,0,0,.9-.07A6,6,0,0,0,310.23,174.36Z",
  fill: "#6c6c6c"
});

var SvgMagnifierSearchfield = function SvgMagnifierSearchfield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 450.9,
    height: 451,
    viewBox: "0 0 450.9 451",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMagnifierSearchfield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/magnifier_searchfield.751bd529.svg";
export { ForwardRef as ReactComponent };